import { Button, ConversationState, Actions } from "@twilio/flex-ui";
import { useState } from "react";
import ExceptionLogger from "../../../../../ExceptionHelper";
import { LeaveChatActionPayload } from "../../types/ActionPayloads";

interface LeaveChatButtonProps {
  conversation: ConversationState.ConversationState;
  size?: "small" | "medium" | "large";
  onLeaveChatComplete?: () => void; 
}

const LeaveChatButton = ({ conversation, size = "small", onLeaveChatComplete }: LeaveChatButtonProps) => {
  const [buttonDisabled, setButtonDisable] = useState(false);
  const handleLeaveChatClick = () => {
    if (conversation) {
      setButtonDisable(true);
      const payload: LeaveChatActionPayload = { conversation };
      Actions.invokeAction("LeaveChat", payload)
        .then(() => {
          if (onLeaveChatComplete) {
            onLeaveChatComplete();
          }
        })
        .catch((err) => {
          console.error("handleLeaveChatClick Error: ", err);
          setButtonDisable(false); 
          ExceptionLogger(err, "LeaveChatButton", "Error invoking leave chat action", "", "");
        });
    }
  };
  return (
    <Button
      variant="primary"
      className="Twilio-TaskCanvasHeader-EndButton"
      size={size}
      onClick={handleLeaveChatClick}
      disabled={buttonDisabled}
    >
      Leave Chat
    </Button>
  );
};

export default LeaveChatButton;
